var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shehuigongnengkaifake"},[_c('CertQuery',{attrs:{"logo":_vm.Logo20,"type":'tnjh',"color":'#294db0'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }